var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkAlt = function SvgLinkAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004586",
    d: "M9 5.998V8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h2.012m1.994 0H8.5a.5.5 0 0 1 .5.5v2.504M8.75 1.25l-4 4",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgLinkAlt as ReactComponent };
export default __webpack_public_path__ + "b542d4dde7179638fcc27ff74c81eb57.svg";